import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'
import 'firebase/firestore'
import 'firebase/storage'
import VueLocalForage from 'vue-localforage'
import _ from '@/assets/lib/my-lodash'
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID
}
// Mail Link login setting
const actionCodeSettings = {
  url: process.env.VUE_APP_SITE_URL,
  handleCodeInApp: true
}

firebase.initializeApp(firebaseConfig)
const storeSettings = {
  timestampsInSnapshots: true
}
const LAST_SAVE_DATE_SAVE_KEY = 'lastSaveDate'
// バックアップ対象
// 'yagiProfile'は端末ごとに持たせるため除外
const BACKUP_KEYS_LIST = [
  'format_rirekisho',
  'format_shokumukeirekisho',
  'basicData',
  'recentEdit',
  LAST_SAVE_DATE_SAVE_KEY
]
const BACKUP_VERSION = 'v20180606-01'
const SITE_ID = process.env.VUE_APP_SITE_ID
const createFirestorePaths = function (uid, docId) {
  if (!uid) {
    console.error('uid not set')
    return {}
  }
  if (!docId) {
    docId = ''
  }
  let paths = {
    userdata: `userdata`,
    userDoc: `userdata/${uid}`,
    backups: `userdata/${uid}/backups`,
    configs: `userdata/${uid}/configs`,
    omikujis: `userdata/${uid}/omikujis`,
    postcards: `userdata/${uid}/postcards`,
    statistics: `serverdata/${uid}/statistics`,
    statisticsOmikuji: `serverdata/${uid}/statistics/omikuji`
  }
  if (docId) {
    const docPaths = {
      omikujiDoc: `userdata/${uid}/omikujis/${docId}`
    }
    paths = Object.assign(paths, docPaths)
  }
  return paths
}
const CONFIG_DOCUMENT_ID = SITE_ID
const DEFAULT_QUERY_LIMIT_NUM = 10
// BACKUP_QUERY_LIMIT_NUM 分取得
const BACKUP_QUERY_LIMIT_NUM = 10
// BACKUP_SAVE_LIMIT_NUMを超えた分を削除する
const BACKUP_SAVE_LIMIT_NUM = 50
let AUTO_BACKUP_INTERVAL_SECONDS = 60

if (process.env.NODE_ENV === 'development') {
  // AUTO_BACKUP_INTERVAL_SECONDS = 15
  // console.log('NODE_ENV is development so AUTO_BACKUP_INTERVAL_SECONDS is', AUTO_BACKUP_INTERVAL_SECONDS)
  console.log('firebaseConfig', firebaseConfig)
}
const AUTO_BACKUP_INTERVAL_MS = AUTO_BACKUP_INTERVAL_SECONDS * 1000

const FirebaseLib = {
  install: function (Vue, options) {
    Vue.use(VueLocalForage)
    const main = new Vue({
      data: function () {
        return {
          accessToken: '',
          db: {},
          user: {},
          userConfig: {},
          lastBackupSaveDate: null,
          lastLocalSaveDate: null,
          autoBackupTimer: null,
          isAddingBackupNow: false,
          isLoginAction: false
        }
      },
      computed: {
        config: function () {
          return firebaseConfig
        },
        authProviderGoogle: function () {
          return new firebase.auth.GoogleAuthProvider()
        },
        isAuthenticated: function () {
          if (this.user && this.user.uid) {
            return true
          } else {
            return false
          }
        },
        firestorePaths: function () {
          if (!this.user || !this.user.uid) {
            return
          }
          return createFirestorePaths(this.user.uid)
        },
        backupStatus: function () {
          if (this.isAddingBackupNow) {
            return {
              type: 'now',
              message: '現在バックアップ中です'
            }
          } else if (this.lastBackupSaveDate) {
            return {
              type: 'done',
              message: this.lastBackupSaveDate
            }
          } else {
            return {
              type: 'none',
              message: ''
            }
          }
        }
      },
      methods: {
        reloadToken: function () {
          const app = this
          console.error(app.accessToken)
          return this.user
            .getIdToken(true)
            .then(function (idToken) {
              app.accessToken = idToken
            })
            .catch(function (err) {
              console.error(err)
            })
        },
        createCollectionQuery: function (path, limit) {
          if (!limit) {
            limit = DEFAULT_QUERY_LIMIT_NUM
          }
          return this.db
            .collection(path)
            .where('uid', '==', this.user.uid)
            .where('site', '==', SITE_ID)
            .orderBy('timestamp', 'desc')
            .limit(limit)
        },
        createUnlimitedCollectionQuery: function (path) {
          return this.db
            .collection(path)
            .where('uid', '==', this.user.uid)
            .where('site', '==', SITE_ID)
            .orderBy('timestamp', 'desc')
        },
        createCollectionQuery4Admin: function (path, limit) {
          if (!limit) {
            limit = DEFAULT_QUERY_LIMIT_NUM
          }
          return this.db
            .collection('userdata')
            .limit(10)
        },
        signInFacebook: function () {
          var provider = new firebase.auth.FacebookAuthProvider();
          firebase.auth().signInWithRedirect(provider)
        },
        signInApple: function () {
          var provider = new firebase.auth.OAuthProvider('apple.com')
          provider.addScope('email')
          provider.setCustomParameters({
            locale: 'ja'
          });
          firebase.auth().signInWithRedirect(provider)
        },
        signInGoogle: function () {
          firebase.auth().signInWithRedirect(this.authProviderGoogle)
        },
        signInEmail: function (email) {
          const app = this
          firebase
            .auth()
            .sendSignInLinkToEmail(email, actionCodeSettings)
            .then(function () {
              // The link was successfully sent. Inform the user.
              // Save the email locally so you don't need to ask the user for it again
              // if they open the link on the same device.
              app.$message({
                message: email + 'にログインURLを送りました',
                type: 'success'
              })
              app.$eventHub.$emit('sing-in-mail-send')
              app.$setItem('emailForSignIn', email)
            })
            .catch(function (error) {
              console.error(error)
              app.$message({
                message: 'メールログインが失敗しました',
                type: 'error'
              })
              app.$eventHub.$emit('sing-in-mail-fail')
              // Some error occurred, you can inspect the code: error.code
            })
        },
        signOut: function () {
          const app = this
          firebase
            .auth()
            .signOut()
            .then(function () {
              // Sign-out successful.
              app.$cookies.config(0,'')
              app.$cookies.remove('_YAGISH_SESSION_KEY', null, 'yagish.jp')
              app.$cookies.set('_YAGISH_SESSION_LOGOUT', "LOGOUT", null, null, 'yagish.jp')
              app.$message({
                message: 'ログアウトしました',
                type: 'info'
              })
            })
            .catch(function (error) {
              app.$message({
                message: 'ログアウトに失敗しました',
                type: 'error'
              })
              console.error(error)
            })
        },
        deleteUser: function () {
          if (!this.isAuthenticated || !this.user) {
            this.$message({
              message: 'アカウントの削除にはログインが必要です',
              type: 'error'
            })
            return false
          }
          return this.user.delete()
        },
        showResultMessage: function (message, type) {
          this.$message({
            message: message,
            type: type,
            duration: 6000
          })
        },
        setupDb: function () {
          this.db = firebase.firestore()
          this.db.settings(storeSettings)
        },
        updateUserDocTimestamp: function () {
          const userDocRef = this.db.doc(this.firestorePaths.userDoc)
          userDocRef.set({
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
          }, {
            merge: true
          })
        },
        loadBackup: function (id) {
          let errors = []
          const app = this
          this.db
            .collection(this.firestorePaths.backups)
            .doc(id)
            .get()
            .then(function (documentSnapshot) {
              if (!documentSnapshot.exists) {
                app.$message({
                  message: 'バックアップデータが見つかりませんでした',
                  type: 'error'
                })
                return
              }
              let data = JSON.parse(documentSnapshot.data().content)
              _.forEach(BACKUP_KEYS_LIST, function (key) {
                if (data.hasOwnProperty(key)) {
                  let dataForLocal = data[key]
                  app.$setItem(key, dataForLocal, function (err) {
                    if (err) {
                      console.error(err)
                      errors.push(err)
                      return
                    }
                    console.log('backup-loaded:', key, dataForLocal)
                    app.$eventHub.$emit('backup-loaded-' + key, dataForLocal)
                  })
                }
              })
              if (errors.length === 0) {
                app.$message({
                  message: 'バックアップを読み込みました:' +
                    documentSnapshot.data().label,
                  type: 'success'
                })
              }
            })
            .catch(function (error) {
              app.$message({
                message: 'バックアップの読み込みに失敗しました',
                type: 'error'
              })
              console.error(error)
            })
        },
        deleteBackup: function (id) {
          return this.db
            .collection(this.firestorePaths.backups)
            .doc(id)
            .delete()
            .then(function () {
              console.log('Document successfully deleted!')
              return true
            })
            .catch(function (error) {
              console.error('Error removing document: ', error)
              return false
            })
        },
        deleteBackupWithMessage: function (id, label) {
          const app = this
          app.db
            .collection(this.firestorePaths.backups)
            .doc(id)
            .delete()
            .then(function () {
              app.$message({
                message: label + 'を削除しました'
              })
              return true
            })
            .catch(function (error) {
              app.$message({
                message: 'バックアップの削除に失敗しました',
                type: 'error'
              })
              console.error('Error removing document: ', error)
              return false
            })
        },
        loadLastBackupSaveDate: function () {
          const app = this
          let query = this.createCollectionQuery(this.firestorePaths.backups, 1)
          return query
            .get()
            .then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                if (!doc.exists) {
                  console.log('no backup exists')
                  throw new Error('noBackup')
                }
                if (!doc.data().lastSaveDate) {
                  return
                }
                // console.log('doc.data().lastSaveDate', doc.id)
                if (typeof doc.data().lastSaveDate.toDate !== 'undefined') {
                  app.lastBackupSaveDate = doc.data().lastSaveDate.toDate()
                } else {
                  // console.log('lastSaveDate is String', new Date(doc.data().lastSaveDate))
                  app.lastBackupSaveDate = new Date(doc.data().lastSaveDate)
                }
              })
            })
            .catch(function (e) {
              console.error(e)
              throw new Error('queryError', e)
            })
        },
        loadLastLocalSaveDate: function () {
          const app = this
          return this.$getItem(LAST_SAVE_DATE_SAVE_KEY).then(function (data) {
            if (!data) {
              // console.log('no local data exists')
              throw new Error('noLocalData')
            }
            try {
              app.lastLocalSaveDate = new Date(data)
            } catch (e) {
              app.lastLocalSaveDate = data
            }
          })
        },
        needAddingBackup: async function () {
          if (!this.isAuthenticated) {
            return false
          }
          try {
            await this.loadLastBackupSaveDate()
            await this.loadLastLocalSaveDate()
          } catch (e) {
            if (e.message === 'noLocalData') {
              return false
            }
            if (e.message === 'noBackup') {
              return true
            }
            console.error('un expected error on load LastSaveDates', e)
            return false
          }
          // console.log('lastBackupSaveDate', this.lastBackupSaveDate)
          // console.log('lastLocalSaveDate ', this.lastLocalSaveDate)
          if (this.lastLocalSaveDate > this.lastBackupSaveDate) {
            return true
          } else {
            return false
          }
        },
        alertIfNeedsLoadingBackup: async function () {
          if (!this.isAuthenticated) {
            return false
          }
          let errorMessage = ''
          try {
            await this.loadLastBackupSaveDate()
            await this.loadLastLocalSaveDate()
          } catch (e) {
            errorMessage = e.message
            if (errorMessage === 'noBackup') {
              return
            }
          }
          if (!this.lastBackupSaveDate) {
            // console.log('lastBackupSaveDate is empty')
            return
          }
          if (
            errorMessage === 'noLocalData' &&
                this.lastBackupSaveDate.getTime()
          ) {
            this.$message({
              type: 'info',
              message: 'サーバーにバックアップがあるよ！'
            })
            return
          }
          if (this.lastLocalSaveDate.getTime() >= this.lastBackupSaveDate.getTime()) {
            console.log('データは最新です')
            return
          }
          if (this.lastLocalSaveDate < this.lastBackupSaveDate) {
            this.$eventHub.$emit(
              'yagi-message',
              'サーバーに新しいバックアップがあるよ！',
              5000
            )
          }
        },
        getBackupList: function (type, limit) {
          if (!this.isAuthenticated) {
            console.log('getBackupList !this.isAuthenticated')
            return
          }
          let query = this.createCollectionQuery(this.firestorePaths.backups, limit)
          if (type === 'user' || type === 'auto') {
            query = query.where('type', '==', type)
          } else {
            type = 'all'
          }
          return query.get()
        },
        getBackupList4Admin: function (type, limit) {
          const app = this
          if (!this.isAuthenticated) {
            console.log('getBackupList4Admin !this.isAuthenticated')
            return
          }
          let membercount = 0
          let backupcount = 0
          console.log('111')
          let query = this.createCollectionQuery4Admin(this.firestorePaths.backups, limit)
          query.get()
            .then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                membercount++
                console.log(`membercount/${membercount}/`)
                let userdataPath = `userdata/${doc.id}/backups`
                let subQuery = app.createUnlimitedCollectionQuery(userdataPath)
                subQuery.get()
                  .then(function (subQuerySnapshot) {
                    subQuerySnapshot.forEach(function (doc) {
                      console.log('XX')
                      backupcount++
                      console.log(`backupcount/${backupcount}/`)
                    })
                  }).catch(function (err) {
                    console.log('141414')
                    console.error(err)
                  })
              })
            }).catch(function (err) {
              console.log('444')
              console.error(err)
            })
          return query.get()
        },
        deleteOverLimitBackups: function () {
          if (!this.isAuthenticated) {
            return
          }
          const app = this
          let query = this.createCollectionQuery(this.firestorePaths.backups, 100)
          query
            .get()
            .then(function (querySnapshot) {
              let count = 0
              querySnapshot.forEach(function (doc) {
                const docData = doc.data()
                if (count > BACKUP_SAVE_LIMIT_NUM) {
                  if (docData.type === 'auto') {
                    // console.log('will be deleted', docData.label, count)
                    app.deleteBackup(doc.id)
                    console.log('auto backup deleted', doc.id)
                  }
                }
                count++
              })
            })
            .catch(function (e) {
              console.error(e)
              throw new Error('queryError', e)
            })
        },
        autoBackup: async function () {
          if (!this.isAuthenticated) return
          if (!this.userConfig.autoSave || true) {
            console.log('autobackup skip, autoSave is false')
            return
          }
          // console.log('autobackup start')
          if (await this.needAddingBackup()) {
            let label = '自動バックアップ'
            if (this.$yagi.profile.name) {
              label = this.$yagi.profile.name + 'の' + label
            }
            this.addBackup(label, 'auto')
            console.log('auto addBackup!')
          } else {
            // console.log('autobackup skip needAddingBackup is false')
          }
          this.deleteOverLimitBackups()
        },
        addBackup: async function (label, type = 'user') {
          this.isAddingBackupNow = true
          if (!this.isAuthenticated) {
            this.$message({
              message: 'ログインしてください',
              type: 'error'
            })
            return
          }
          let storageData = {}
          await this.$iterateStorage(
            function (value, key, iterationNumber) {
              if (_.includes(BACKUP_KEYS_LIST, key)) {
                storageData[key] = value
              }
            },
            function (err) {
              if (err) {
                console.error(err)
              }
            }
          )
          if (!storageData) {
            this.$message({
              message: 'データがありません',
              type: 'error'
            })
            return
          }
          const backupData = {
            type: type,
            label: label,
            uid: this.user.uid,
            lastSaveDate: storageData.lastSaveDate || null,
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            content: JSON.stringify(storageData),
            version: BACKUP_VERSION,
            site: SITE_ID,
            platform: _.compact([this.$deviceLib.platform.name, this.$deviceLib.platform.product, this.$deviceLib.platform.os]).join(', ')
          }

          const app = this
          try {
            const backup = await this.db
              .collection(this.firestorePaths.backups)
              .add(backupData)

            const formData = new FormData()
            formData.append('uuid', this.user.uid)
            formData.append('backup_uid', backup.id)
            formData.append('site_flag', 'k')
            formData.append('backup_type', type)
            formData.append('backup_name', label)
            formData.append('storage_data', JSON.stringify(storageData))
            this.$axios.post(this.$varuna.endPoints.saveBackupdata, formData, {timeout : 60000 })

            app.$message({
              type: 'success',
              message: '保存成功:' + label
            })
            app.isAddingBackupNow = false
          } catch (error) {
            console.error(error)
            app.$message({
              type: 'error',
              message: '保存失敗:' + label
            })
            app.isAddingBackupNow = false
          }
        },
        addOmikujiLog: async function (omikuji) {
          if (!this.isAuthenticated) {
            console.log('not authenticated, addOmikujiLog skipped')
            return
          }
          if (!omikuji) {
            this.$message({
              message: 'おみくじデータがありません',
              type: 'error'
            })
            return
          }
          const omikujiData = {
            content: omikuji,
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            site: SITE_ID
          }
          return this.db.collection(this.firestorePaths.omikujis).add(omikujiData)
        },
        omikujiStatisticsOnSnapshot: function (callback) {
          if (!this.isAuthenticated) {
            console.log('not authenticated, getOmikujiStatistics skipped')
            return
          }
          return this.db.doc(this.firestorePaths.statisticsOmikuji).onSnapshot(callback)
        },
        addPostCard: function (postCard) {
          if (!this.isAuthenticated) {
            return
          }
          if (!postCard) {
            this.$message({
              message: 'はがきの内容がありません',
              type: 'error'
            })
            return
          }
          const postCardData = {
            content: postCard,
            author: {
              uid: this.user.uid,
              email: this.user.email
            },
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            site: SITE_ID
          }
          return this.db
            .collection(this.firestorePaths.postcards)
            .add(postCardData)
        },
        getPostCardList: function (startAfter) {
          if (!this.isAuthenticated) {
            return
          }
          let query = this.db
            .collection(this.firestorePaths.postcards)
            .limit(BACKUP_QUERY_LIMIT_NUM)
            .orderBy('timestamp', 'desc')
          if (startAfter) {
            query = query.startAfter(startAfter)
          }
          return query.get()
        },
        getPostCardListOnSnapshot: function (callback) {
          if (!this.isAuthenticated) {
            return
          }
          let query = this.db
            .collection(this.firestorePaths.postcards)
            .limit(BACKUP_QUERY_LIMIT_NUM)
            .orderBy('timestamp', 'desc')
          return query.onSnapshot(callback)
        },
        loadUserConfig: function () {
          if (!this.isAuthenticated) {
            console.log('not authenticated. loadUserConfig skipped')
            return
          }
          const app = this
          return app.db
            .collection(this.firestorePaths.configs)
            .doc(CONFIG_DOCUMENT_ID)
            .get()
            .then(function (doc) {
              if (doc.exists) {
                app.userConfig = doc.data()
              } else {
                console.log('not config use default')
                app.userConfig = {
                  uid: app.user.uid,
                  autoSave: true
                }
              }
            })
            .catch(function (error) {
              console.log(app.user.uid)
              console.error('Error getting document:', error)
            })
        },
        saveUserConfig: function () {
          if (!this.isAuthenticated) {
            console.log('not authenticated. saveUserConfig skipped')
            return
          }
          const app = this
          let userConfig = app.userConfig
          userConfig.uid = app.user.uid
          return app.db
            .collection(this.firestorePaths.configs)
            .doc(CONFIG_DOCUMENT_ID)
            .set(app.userConfig)
            .then(function () {
              console.log('saveUserConfig success')
            })
            .catch(function (err) {
              console.log('saveUserConfig error:', err)
            })
        },
        activateAutoBackup: function () {
          if (!this.autoBackupTimer) {
            this.autoBackupTimer = setInterval(
              this.autoBackup,
              AUTO_BACKUP_INTERVAL_MS
            )
          } else {
            console.log('autoBackupTimer already exists. skip')
          }
        },
        deactivateAutoBackup: function () {
          clearInterval(this.autoBackupTimer)
        },
        authTest: function () {
          const auth = firebase.functions().httpsCallable('authTest')
          auth({ text: 'test' }).then(function (result) {
            console.log(result)
          }).catch(err => {
            console.error(err)
          })
        },
        init: function () {
          this.setupDb()
          this.loadUserConfig()
          this.activateAutoBackup()
          this.alertIfNeedsLoadingBackup()
          this.updateUserDocTimestamp()
          this.$eventHub.$emit('firebase-initialized', this.user)
        }
      }
    })
    firebase
      .auth()
      .getRedirectResult()
      .then(function (result) {
        if (result.credential) {
          if (result.user.email) {
            main.showResultMessage(
              'ログインしました。：' + result.user.email,
              'success'
            )
            main.isLoginAction = true
            const formData = new FormData()
            formData.append('uuid', result.user.uid)
            formData.append('email', result.user.email)
            var confirm_code  = main.$cookies.get('_TEMPDATA_CONFIRM_CODE')
            formData.append('confirm_code', confirm_code)
            formData.append('app_flag', '')
            formData.append('site_flag', 'k')
            formData.append('device_flag', main.$deviceLib.isMobileDevice ? 'SP': 'PC')
            main.$axios
              .post(main.$varuna.endPoints.login, formData)
          } else {
            main.showResultMessage(
              'ログインしました。',
              'success'
            )
            main.isLoginAction = true
            const formData = new FormData()
            formData.append('uuid', result.user.uid)
            formData.append('email', '')
            var confirm_code  = main.$cookies.get('_TEMPDATA_CONFIRM_CODE')
            formData.append('confirm_code', confirm_code)
            formData.append('app_flag', '')
            formData.append('site_flag', 'k')
            formData.append('device_flag', main.$deviceLib.isMobileDevice ? 'SP': 'PC')
            main.$axios
              .post(main.$varuna.endPoints.login, formData)
          }
        }
      })
      .catch(function (error) {
        main.showResultMessage(
          'ログインに失敗しました：' + error.message,
          'error'
        )
      })
    if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
      // Additional state parameters can also be passed via URL.
      // This can be used to continue the user's intended action before triggering
      // the sign-in operation.
      // Get the email if available. This should be available if the user completes
      // the flow on the same device where they started it.
      main.$getItem('emailForSignIn').then(function (email) {
        if (!email) {
          // User opened the link on a different device. To prevent session fixation
          // attacks, ask the user to provide the associated email again. For example:
          email = window.prompt(
            '別の端末でログインする場合、安全のため再度メールアドレスを入力してください。\n※一度使用したメールリンクは無効となります'
          )
        }
        if (main.user.email) {
          main.showResultMessage('すでにログイン済みです')
          return
        }
        if (!email) {
          main.showResultMessage('再度ログインし直してください:', main.user.email)
          return
        }
        // The client SDK will parse the code from the link for you.
        firebase
          .auth()
          .signInWithEmailLink(email, window.location.href)
          .then(function (result) {
            // Clear email from storage.
            main.showResultMessage('ログインしました：' + result.user.email)
            main.isLoginAction = true
            main.$removeItem('emailForSignIn')
            const formData = new FormData()
            formData.append('uuid', result.user.uid)
            formData.append('email', result.user.email)
            var confirm_code  = main.$cookies.get('_TEMPDATA_CONFIRM_CODE')
            formData.append('confirm_code', confirm_code)
            formData.append('app_flag', '')
            formData.append('site_flag', 'k')
            formData.append('device_flag', main.$deviceLib.isMobileDevice ? 'SP': 'PC')
            main.$axios
              .post(main.$varuna.endPoints.login, formData)
            // You can access the new user via result.user
            // Additional user info profile not available via:
            // result.additionalUserInfo.profile == null
            // You can check if the user is new or existing:
            // result.additionalUserInfo.isNewUser
          })
          .catch(function (error) {
            console.error(error)
            main.showResultMessage(
              'ログインに失敗しました。メールリンクを再度送信してください。',
              'error'
            )
            // Some error occurred, you can inspect the code: error.code
            // Common errors could be invalid email and invalid or expired OTPs.
          })
      })
    }
    firebase.auth().onAuthStateChanged(function (user) {
      console.error(main.$yagi.is_logging)
      main.$yagi.is_logging = true
      main.user = user
      if (user) {
        var logout_cookie  = main.$cookies.get('_YAGISH_SESSION_LOGOUT')
        if (logout_cookie == "LOGOUT" && !main.isLoginAction) {
          main.$cookies.remove('_YAGISH_SESSION_LOGOUT', null, 'yagish.jp')
          firebase
            .auth()
            .signOut()
        } else {
          main.init()
          main.$cookies.config(0,'')
          main.$cookies.set('_YAGISH_SESSION_KEY', main.user.uid, null, null, 'yagish.jp')
        }
        main.$yagi.is_logging = false
      } else {
        main.deactivateAutoBackup()
        var login_cookie  = main.$cookies.get('_YAGISH_SESSION_KEY')
        if (login_cookie === null) {
          main.$yagi.is_logging = false
        } else {
          const formData = new FormData()
          formData.append('uuid', login_cookie)
          main.$axios
          .post(main.$varuna.endPoints.gettoken, formData)
          .then(function (response) {
            console.error(response.data.ct)
            firebase.auth().signInWithCustomToken(response.data.ct)
            .then((userCredential) => {
              main.user = userCredential.user
              main.$cookies.config(0,'')
              main.$cookies.set('_YAGISH_SESSION_KEY', main.user.uid, null, null, 'yagish.jp')
              main.$yagi.is_logging = false
            })
            .catch((error) => {
              var errorCode = error.code
              var errorMessage = error.message
              console.error(errorCode)
              console.error(errorMessage)
            });
          })
        }

      }
    })
    Vue.prototype.$firebase = main
  }
}
export default FirebaseLib
